import React, { useState, useCallback, useEffect } from 'react';
import { Button, ButtonColor, ButtonType } from '@lux/buttons';
import { Text, Preset } from '@lux/text';
import { ControlsCloseXS, IconSize } from '@lux/icons';
import { Translate, TranslateProvider, TranslateScope } from '@pegasus/translation';
import { OS_IOS } from '@pegasus/utils';
import useScrollToggle from '../hooks/useScrollToggle';
import { tracker, Event } from '../track';
import { getCountyAppStoreUrls, DEFAULT_COUNTRY, APP_REVIEWS_COUNT_IOS, APP_REVIEWS_COUNT_ANDROID, } from '../config';
import StarRating from '../rating';
import { isSmartBannerClosed, setSmartBannerStorageItem } from '../utils';
import { SmartBannerContainer, SmartBannerCloseButton, SmartBannerMiddleSection, SmartBannerLoungeLogo, SmartBannerCtaButton, SmartBannerContentWraper, SmartBannerContentAndLogoWraper, } from './index.styles';
export const getStoreUrl = (localeCountry, storeUrlFromExternalAsProp = '', bannerContext) => {
    if (storeUrlFromExternalAsProp)
        return storeUrlFromExternalAsProp;
    const appStoreUrls = getCountyAppStoreUrls(bannerContext);
    return appStoreUrls[localeCountry] || appStoreUrls[DEFAULT_COUNTRY];
};
const getReviewsCount = (reviewCount, appPlatform) => reviewCount || (appPlatform === OS_IOS ? APP_REVIEWS_COUNT_IOS : APP_REVIEWS_COUNT_ANDROID);
export const SmartBanner = ({ onCtaClick, onClose, stopNavigate = false, hideInSafariBrowserOfiOS = false, appStoreUrl, localeCountry, translations, appPlatform, reviewCount = '', listenToBannerPosition, bannerContext = 'mylounge', page = '', }) => {
    const pageName = page || bannerContext;
    const storeUrl = getStoreUrl(localeCountry, appStoreUrl, bannerContext);
    const [isClosed, setIsClosed] = useState(() => isSmartBannerClosed(bannerContext) || hideInSafariBrowserOfiOS);
    const [isViewed, setIsViewed] = useState(false);
    const isShown = useScrollToggle(180);
    useEffect(() => {
        if (!isViewed && isShown) {
            setIsViewed(true);
            tracker.track(Event.VIEW, { component: `appBanner_${bannerContext}` });
        }
    });
    const onBannerClick = useCallback(() => {
        var _a;
        tracker.track(Event.CLICK, { component: `appBanner_${bannerContext}` });
        if (onCtaClick) {
            onCtaClick(storeUrl);
        }
        if (storeUrl && !stopNavigate) {
            (_a = window.open(storeUrl, '_blank')) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [onCtaClick]);
    const handleBannerRemoval = useCallback((isUserClosed) => {
        setSmartBannerStorageItem({
            [pageName]: 'true',
        });
        if (onClose) {
            onClose(isUserClosed);
        }
    }, [onClose, pageName]);
    const onCloseBanner = useCallback(() => {
        tracker.track(Event.CLOSE, { component: `appBanner_${bannerContext}` });
        handleBannerRemoval(true);
        setIsClosed(true);
    }, [setIsClosed]);
    useEffect(() => {
        if (isClosed) {
            handleBannerRemoval();
        }
    }, [isClosed, onClose]);
    useEffect(() => {
        if (listenToBannerPosition && !isClosed) {
            listenToBannerPosition(isShown);
        }
    }, [listenToBannerPosition, isShown, isClosed]);
    if (isClosed || !storeUrl) {
        if (onClose) {
            onClose();
        }
        return null;
    }
    return (React.createElement(TranslateProvider, { translations: translations },
        React.createElement(TranslateScope, { path: "smartbanner" },
            React.createElement(SmartBannerContainer, { isShown: isShown },
                React.createElement(SmartBannerCloseButton, { onClick: onCloseBanner, onKeyPress: onCloseBanner, "aria-label": "Close", type: "button" },
                    React.createElement(ControlsCloseXS, { "aria-hidden": "true" })),
                React.createElement(SmartBannerMiddleSection, null,
                    React.createElement(SmartBannerContentAndLogoWraper, null,
                        React.createElement(SmartBannerLoungeLogo, { size: IconSize.S, color: "currentColor", fillRule: "nonzero" }),
                        React.createElement(SmartBannerContentWraper, null,
                            React.createElement(Text, { preset: Preset.S, bold: true },
                                React.createElement(Translate, { message: "appBrandName" })),
                            React.createElement(StarRating, { reviewscount: getReviewsCount(reviewCount, appPlatform) })))),
                React.createElement(SmartBannerCtaButton, null,
                    React.createElement(Button, { color: ButtonColor.bright, buttonType: ButtonType.primary, onClick: onBannerClick },
                        React.createElement(Translate, { message: "useApp" })))))));
};
//# sourceMappingURL=index.js.map